"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReplayEpic = void 0;
var _reduxObservable = require("redux-observable");
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
var _DialogState = require("../../../ui/enums/DialogState");
var _DetermineIfNewRoundCanBestarted = require("../../common/helpers/DetermineIfNewRoundCanBestarted");
var _CommandType = require("../../dovahzul/CommandType");
var _ReplayRequest = require("../../dovahzul/requests/ReplayRequest");
var _actions = require("../bet/actions");
var _types = require("../blitz/types");
var _types2 = require("../com/types");
var _Core = _interopRequireDefault(require("../Core"));
var _types3 = require("../game/types");
var _types4 = require("../ui/types");
var _types5 = require("./types");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * handles all logic for in game replays and "instant replays" of rounds previously played.
 */
var ReplayEpic = exports.ReplayEpic = /*#__PURE__*/_createClass(function ReplayEpic() {
  var _this = this;
  _classCallCheck(this, ReplayEpic);
  _defineProperty(this, "getEpic", function () {
    return (0, _reduxObservable.combineEpics)(_this.replayRound, _this.commandRoundStartResponse, _this.roundEnd, _this.commandReplayLaunch, _this.demoRound);
  });
  /**
   * 
   * Server has sent the commands for a replay. this firs on round start response that has the replay flag as true.
   * @param action$ 
   * @param store 
   * @returns 
   */
  _defineProperty(this, "commandRoundStartResponse", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.RoundStartResponse === a.payload.type && a.payload.replay;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.of)({
        type: _types5.REPLAY_ROUND_START,
        payload: {
          roundId: a.payload.roundId,
          bet: {
            coins: store.value.bet.coins,
            lines: store.value.bet.lines,
            denomination: store.value.bet.denomination
          }
        }
      });
    }));
  });
  /**
   * When player or client trigger a replay of a round.
   * 
   * @param action$ 
   * @param store 
   * @returns 
   */
  _defineProperty(this, "replayRound", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.REPLAY_ROUND), (0, _operators.filter)(function () {
      return (0, _DetermineIfNewRoundCanBestarted.DetermineIfNewRoundCanBeStartedReplay)(store.value) && store.value.config.ire;
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.com.connectionState === _types2.ConnectionState.Reconnecting) {
        console.warn("reconnecting");
        // we kinda just swallow this and assume player will understand there is an connection issue. might want to be better to do a dialog.
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types4.STATUS_TEXT_SET,
          payload: {
            value: _Core["default"].translate("reconnecting")
          }
        }));
      }
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.BLITZ_MODE_OFF
      }), (0, _rxjs.of)({
        type: _types4.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: _DialogState.DialogState.REPLAY_START,
          actions: {
            DIALOG_OK: [{
              type: _types2.COMMAND_SEND,
              payload: new _ReplayRequest.ReplayRequest(a.payload.roundId)
            }, {
              type: _types3.ROUND_START
            }
            // { type: REELS_SPIN }  This might be needed, buyt it screews up the freespin counter on replay aswell...
            ]
          }
        }
      }));
    }));
  });
  _defineProperty(this, "demoRound", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types5.REPLAY_ROUND_DEMO), (0, _operators.filter)(function () {
      return (0, _DetermineIfNewRoundCanBestarted.DetermineIfNewRoundCanBeStartedReplay)(store.value);
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.com.connectionState === _types2.ConnectionState.Reconnecting) {
        console.warn("reconnecting");
        // we kinda just swallow this and assume player will understand there is an connection issue. might want to be better to do a dialog.
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types4.STATUS_TEXT_SET,
          payload: {
            value: _Core["default"].translate("reconnecting")
          }
        }));
      }
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types.BLITZ_MODE_OFF
      }), (0, _rxjs.of)({
        type: _types3.ROUND_START
      }), (0, _rxjs.of)({
        type: _types2.COMMAND_SEND,
        payload: new _ReplayRequest.ReplayRequest(a.payload.roundId)
      }));
    }));
  });
  /**
  * handle when server says its just a replay launch, not a real game start.. 
  * @param action$ 
  * @returns 
  */
  _defineProperty(this, "commandReplayLaunch", function (action$) {
    return action$.pipe((0, _reduxObservable.ofType)(_types2.COMMAND_RECEIVED), (0, _operators.filter)(function (a) {
      return _CommandType.CommandType.ReplayResponse === a.payload.type;
    }), (0, _operators.mergeMap)(function (a) {
      return (0, _rxjs.concat)((0, _rxjs.of)({
        type: _types5.REPLAY_ROUND_LAUNCH,
        payload: a.payload
      }), (0, _rxjs.of)({
        type: _types.BLITZ_MODE_OFF
      }), (0, _rxjs.of)({
        type: _types4.REQUEST_DIALOG_STATE_ACTIONS,
        payload: {
          state: _DialogState.DialogState.REPLAY_START_LAUNCH,
          actions: {
            DIALOG_OK: [{
              type: _types2.COMMAND_QUEUE_NEXT
            }, {
              type: _types3.ROUND_START
            }
            // { type: REELS_SPIN }  This might be needed, buyt it screews up the freespin counter on replay aswell...
            ]
          }
        }
      }));
    }));
  });
  /**
   * When a replay is over.  Only fires on round end if there was an actuall replay active.
   * 
   * @param action$ 
   * @param store 
   * @returns 
   */
  _defineProperty(this, "roundEnd", function (action$, store) {
    return action$.pipe((0, _reduxObservable.ofType)(_types3.ROUND_END), (0, _operators.filter)(function () {
      return store.value.config.ire && store.value.replay.playingReplay;
    }), (0, _operators.mergeMap)(function (a) {
      if (store.value.replay.mode === _types5.ReplayMode.Demo) {
        return (0, _rxjs.concat)((0, _rxjs.of)((0, _actions.updateBet)(store.value.replay.previousBet)), (0, _rxjs.of)({
          type: _types4.STATUS_TEXT_STATE,
          payload: _types4.StatusTextState.Idle
        }), (0, _rxjs.of)({
          type: _types5.REPLAY_ROUND_END
        }));
      }
      if (store.value.replay.replayLaunch) {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types4.REQUEST_DIALOG_STATE_ACTIONS,
          payload: {
            state: _DialogState.DialogState.REPLAY_END_LAUNCH,
            actions: {
              DIALOG_NO: [{
                type: _types3.EXIT
              }],
              DIALOG_OK: [{
                type: _types2.COMMAND_SEND,
                payload: new _ReplayRequest.ReplayRequest(store.value.replay.roundId)
              }, {
                type: _types2.COMMAND_QUEUE_NEXT
              }, {
                type: _types3.ROUND_START
              }]
            }
          }
        }));
      } else {
        return (0, _rxjs.concat)((0, _rxjs.of)({
          type: _types4.REQUEST_DIALOG_STATE,
          payload: _DialogState.DialogState.REPLAY_END
        }), (0, _rxjs.of)((0, _actions.updateBet)(store.value.replay.previousBet)), (0, _rxjs.of)({
          type: _types4.STATUS_TEXT_STATE,
          payload: _types4.StatusTextState.Idle
        }), (0, _rxjs.of)({
          type: _types5.REPLAY_ROUND_END
        }));
      }
    }));
  });
});
//# sourceMappingURL=epics.js.map